<template>
    <el-card class="box-card" shadow="always">
        <div class="title_btn"> *banner配置</div>

        <div class="case_wrap">
            <div class="case_left">
                <div class="case-item">
                    <span class="label">*pc端banner（{{ bannerInfo.bannerImg.length }}/1）</span>
                    <div>
                        <imageUpload v-model="bannerInfo.bannerImg" :limit="1" />
                        <div class="el-upload__tip">建议尺寸为1920*580</div>
                    </div>
                </div>

                <div class="case-item">
                    <span class="label">自定义ALT</span>
                    <el-input v-model="bannerInfo.banner_alt" placeholder="请填写自定义ALT"></el-input>
                </div>
            </div>

            <div class="case_left">
                <div class="case-item">
                    <span class="label">*pc端icon图（{{ bannerInfo.iconImg.length }}/1)</span>
                    <div>
                        <imageUpload v-model="bannerInfo.iconImg" :limit="1" />
                        <div class="el-upload__tip">建议尺寸为240*50</div>
                    </div>
                </div>

                <div class="case-item">
                    <span class="label">*icon跳转</span>
                    <el-select v-model="bannerInfo.is_jump" class="icon_type">
                        <el-option label="自定义url" value="1"></el-option>
                        <el-option label="表单" value="2"></el-option>
                    </el-select>
                </div>
            </div>

            <div class="case_left">
                <div class="case-item">
                    <span class="label">*H5端banner（{{ bannerInfo.h5Img .length }}/1）</span>
                    <div>
                        <imageUpload v-model="bannerInfo.h5Img " :limit="1" />
                        <div class="el-upload__tip">建议尺寸为375*550</div>
                    </div>
                </div>

                <div v-if="bannerInfo.is_jump==1" class="case_left">
                    <div class="case-item">
                        <span class="label">*跳转链接</span>
                        <el-input v-model="bannerInfo.jump_url" placeholder="请输入跳转链接"></el-input>
                    </div>
                </div>
            </div>

            <div class="case_left">
                <div class="case-item">
                    <span class="label">*H5端icon图（{{ bannerInfo. h5Icon.length }}/1)</span>
                    <div>
                        <imageUpload v-model="bannerInfo. h5Icon" :limit="1" />
                        <div class="el-upload__tip">建议尺寸为134*40</div>
                    </div>
                </div>
            </div>

        </div>
    </el-card>
</template>
<script>
import baseURL from '@/configs/baseUrl';
import utils from '@/jslibs/utils';
import { imgDomain } from '@/configs/env';
import imageUpload from '@/components/ImageUpload';
export default {

    components: {
        imageUpload
    },
    data() {
        return {
            imgDomain,
            headers: {
                'X-Access-Token': utils.getCookie('X-Access-Token') || ''
            },
            baseURL,
            bannerInfo: {
                bannerImg: [],
                banner_img: "",
                iconImg: [],
                banner_icon: "",
                h5_banner_img: "",
                h5_banner_icon: "",
                h5Img: [],
                h5Icon: [],
                banner_alt: "",
                is_jump: "",
                jump_url: ""
            }
        };
    },

    methods: {
        verifyInput() {
            const { bannerImg, iconImg, h5Img, h5Icon, banner_alt, is_jump, jump_url } = this.bannerInfo;
            if (!bannerImg.length) {
                this.$notify.error({ title: '请上传pc端banner图' });
                return false
            }
            if (!iconImg.length) {
                this.$notify.error({ title: '请上传pc端icon图' });
                return false
            }

            if (!h5Img.length) {
                this.$notify.error({ title: '请上传H5端banner图' });
                return false
            }
            if (!h5Icon.length) {
                this.$notify.error({ title: '请上传H5端icon图' });
                return false
            }
            if (!is_jump) {
                this.$notify.error({ title: '请选择跳转类型' });
                return false
            }
            if (is_jump == 1 && !jump_url) {
                this.$notify.error({ title: '请输入跳转的url' });
                return false
            }
            this.bannerInfo.banner_img = this.bannerInfo.bannerImg.join();
            this.bannerInfo.banner_icon = this.bannerInfo.iconImg.join();
            this.bannerInfo.h5_banner_img = this.bannerInfo.h5Img.join();
            this.bannerInfo.h5_banner_icon = this.bannerInfo.h5Icon.join();
            return true
        }
    }
};
</script>
<style lang="less" scoped>
    .box-card{
        .title_btn{
            margin-bottom: 20px;
        }
        .case_wrap{
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            padding: 20px;
            border: 1px solid #ccc;
            .case-item{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                /deep/ .add-box{
                    padding-left: 0;
                    margin-top: 0;
                }
                .label{
                    width: 120px;
                }
                /deep/.dankal-image-upload{
                    p{
                        margin: 0;
                    }
                }
            }
        }
        .case_wrap .case_left:not(:last-child){
            margin-right: 40px;
        }
        .el-upload__tip{
            color: red;
        }
    }
</style>
